module.exports = __webpack_public_path__ + "img/error.17249605.svg";